import React from 'react';
import {useMatch} from 'react-router-dom';
import Menu from '../Menu';
import {PATHS} from 'Routes';
import {useSummary} from 'context/summary';
import {useReservation} from 'context/reservation';
import {
  DiscardChangesModal,
  DiscardChangesModalRef,
} from '../DiscardChangesModal/DiscardChangesModal';
import {ShoppingCartButton} from '../ShoppingCartButton/ShoppingCartButton';
import {
  HousingLongNameModal,
  HousingLongNameModalPropsRef,
} from '../HousingLongNameModal/HousingLongNameModal';
import {Container, HeaderWrapper, HeaderTitle, LogoContainer, Title} from './styled';

type NavbarProps = {
  visible?: boolean;
  title?: string;
};

const Navbar = ({visible, title}: NavbarProps) => {
  const {data} = useSummary();
  const {housing} = useReservation();
  const discardChangesModalRef = React.useRef<DiscardChangesModalRef>(null);
  const housingLongNameModalRef = React.useRef<HousingLongNameModalPropsRef>(null);
  const isHomeView = useMatch('/:token');
  const name = title || data?.display_name || data?.property_name || '';
  const housingNameLength = name?.length || 0;

  const handleClickOnTitle = React.useCallback(() => {
    if (isHomeView && housingNameLength > 20) {
      housingLongNameModalRef.current?.open();
      return;
    }
    discardChangesModalRef.current?.open(PATHS.home);
  }, [discardChangesModalRef, isHomeView, housingNameLength]);

  return (
    <>
      <HeaderWrapper visible={visible} className="navbar">
        <Container>
          {housing?.picture?.src && (
            <LogoContainer className="navbar__logo">
              <img
                src={housing?.picture?.src}
                alt="housing Logo"
                className="navbar__logo-img"
              />
            </LogoContainer>
          )}
          <HeaderTitle onClick={handleClickOnTitle} className="navbar__title">
            <Title className="navbar__title-text">{name}</Title>
          </HeaderTitle>
          <ShoppingCartButton />
          <Menu />
        </Container>
      </HeaderWrapper>
      <DiscardChangesModal ref={discardChangesModalRef} />
      <HousingLongNameModal ref={housingLongNameModalRef} name={name} />
    </>
  );
};

export {Navbar};
export type {NavbarProps};
